import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import whastapp from "../../assets/images/icons/whastapp.png";
// import FB from "../../assets/images/FB.png";
// import linkedin from "../../assets/images/linkedin.png";
// import twitter from "../../assets/images/twitter.png";
// import { Link } from "react-router-dom";

const Footer = (props) => {
  const location = useLocation();
  const [currentURL, setCurrentURL] = useState('')

  useEffect(() => {
    setCurrentURL(location.pathname);
  }, [location.pathname])





  const [iframeWidth, setIframeWidth] = useState(51);
  const [iframeHeight, setIframeHeight] = useState(51);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.message === 'toggleClass') {
        document.body.classList.toggle('chat-open');
        const isChatOpen = document.body.classList.contains('chat-open');
        if (isChatOpen) {
          setIframeWidth(event.data.width);
          setIframeHeight(event.data.height + 90);
        } else {
          setIframeWidth(51);
          setIframeHeight(51);
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  const isArtGalleryPage = location.pathname.includes('/art-gallery');
  const isBloodPrivacypage = location.pathname.includes('/privacypolicy/bloodgas');

  return (
    <div className={`page-main-wrapper f-wrp ${currentURL === '/art-gallery' ? 'inside-art-wrp' : 'outside-art-wrp'} ${currentURL === '/art' ? 'inside-art-wrp' : 'outside-art-wrp'} ${isBloodPrivacypage ? 'no-header-footer' : null} ${currentURL === '/view-artist' ? 'inside-art-wrp' : 'outside-art-wrp'}` }>
      <div className="container-fluid">
        <div className="container">

          {/* <>
          {!isArtGalleryPage ? <button type="button" id="wamihapp" onClick={() => {
            window.open('https://wa.me/19499928252', '_blank')
          }} className='whatsapp-btn'><img src={whastapp} alt='Whatsapp' /></button> : null}


          {!isArtGalleryPage ? <iframe
            id="chatIframe"
            src="https://pnp-ai.mihapp.co/cricket-ai/cricket-module-helper/chat"
            width={`${iframeWidth}px`}
            height={`${iframeHeight}px`}
            style={{ border: 'none' }}
            title="Chat Assistant"
          /> : null}

</> */}
          {/* </div> */}

          <div className="footer-sec-wrp blk-txt-wrp f-wrp">
            <div className="copy-txt-wrp f-wrp">
              <div className="row">
                <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                  <div className="social-list-wrp f-wrp">
                    <ul className="list-inline">
                      {/* <li className="list-inline-item">
                        <a href={"#"}>
                          <img alt={"no Imag"} src={FB} />
                        </a>
                      </li> */}
                      {/* <li className="list-inline-item">
                        <a href={"#"}>
                          <img alt={"no Imag"} src={linkedin} />
                        </a>
                      </li> */}
                      {/* <li className="list-inline-item">
                        <a href={"#"}>
                          <img alt={"no Imag"} src={twitter} />
                        </a>
                      </li> */}
                    </ul>
                  </div>
                </div>
                <div className="col-lg-8 col-md-8 col-sm-10 col-xs-10 footer-sep">
                  <p className="else">
                    <b style={{ display: 'inline-block', cursor: 'pointer', fontWeight: 'inherit' }} onClick={() => window.location = 'mailto:hello@mihapp.co'}>hello@mihapp.co</b> &nbsp;|&nbsp; Beverly Hills, CA, USA
                  </p>
                  <p className="art">
                    <b style={{ display: 'inline-block', cursor: 'pointer', fontWeight: 'inherit' }} onClick={() => window.location = 'mailto:hello@mihapp.co'}>hello@mihapp.co</b> &nbsp;|&nbsp; Beverly Hills, CA, USA &nbsp;|&nbsp; Dubai, UAE</p>
                </div>
                <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                  <span>© 2023 by Mihapp!</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
